import {Component, OnDestroy, OnInit} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {UserService} from "./_services/user.service";
import {ToasterConfig} from "angular2-toaster";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import * as appConfig from "../../config/app.js";

@Component({
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  appConfig = appConfig;

  public toasterconfig: ToasterConfig =
    new ToasterConfig({
      showCloseButton: true,
      timeout: 0,
      positionClass: 'toast-top-right'
    });

  constructor(private router: Router,
              public userService: UserService,
              public modalService: NgbModal) {}

  ngOnInit() {
    try {
      if (this.userService.loggedIn) {
        this.userService.refreshProfile(() => {
        });
      }
    }
    catch(e) {}

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });
  }

  ngOnDestroy() {}

}
